import {
  USER_DETAILS,
  USER_ROLES,
  USER_SUBSCRIPTION,
  CURRENT_APP,
} from '../constants/commonUiActions';

const user = (state = {}, action) => {
  switch (action.type) {
    case CURRENT_APP:
      return { ...state, appName: action.payload };
    case USER_SUBSCRIPTION:
      return { ...state, subscriptionDetails: action.payload };
    case USER_DETAILS:
      return { ...state, userDetails: action.payload };
    case USER_ROLES:
      return { ...state, userRoles: action.payload };
    default:
      return state;
  }
};

export default user;
